import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Attachment } from '../models/project/attachment/attachment.interface';
import { Observable } from 'rxjs';

@Injectable()
export class AttachmentService {
  private httpClient = inject(HttpClient);

  private attachmentsUrl = '';

  public setAttachmentsUrl(projectId: string, assignmentId: string) {
    this.attachmentsUrl = `${environment.apiUrl}/projects/${projectId}/assignments/${assignmentId}/attachments`;
  }

  public getAssignmentAttachments(): Observable<Attachment[]> {
    return this.httpClient.get<Attachment[]>(`${this.attachmentsUrl}`);
  }

  public createAssignmentAttachments(
    attachments: Attachment[],
    correlationId?: string,
  ): Observable<Attachment[]> {
    return this.httpClient.post<Attachment[]>(
      `${this.attachmentsUrl}`,
      attachments,
      {
        headers: this.buildHeaders(correlationId),
      },
    );
  }

  public createAssignmentAttachment(
    attachment: Attachment,
    correlationId?: string,
  ): Observable<Attachment> {
    return this.httpClient.post<Attachment>(
      `${this.attachmentsUrl}/create-attachment`,
      attachment,
      {
        headers: this.buildHeaders(correlationId),
      },
    );
  }

  public deleteAttachment(id: string): Observable<null> {
    return this.httpClient.delete<null>(`${this.attachmentsUrl}/${id}`);
  }

  public renameFileName(id: string, fileName: string): Observable<Attachment> {
    return this.httpClient.put<Attachment>(`${this.attachmentsUrl}/${id}`, {
      fileName,
    });
  }

  private buildHeaders(correlationId?: string): HttpHeaders | undefined {
    if (!correlationId) {
      return undefined;
    }

    return new HttpHeaders({
      'X-Correlation-Id': correlationId,
    });
  }
}
